import { renderDate } from '../utility/personTabGridHelper';

export const ATTRIBUTE_CATEGORIES = [
  'Appearance',
  'Builds',
  'Complexions',
  'EyeDefect',
  'FacialHair',
  'Glasses',
  'MethodOfOperation',
  'SpeechQuality',
  'Talk',
  'Teeth',
];

export const ATTRIBUTE_CATEGORY_OPTIONS = ATTRIBUTE_CATEGORIES.map((category) => ({
  Code: category,
  Description: category,
}));

export const DEFAULT_VALUES = {
  AttributeCategory: '',
  Attribute: '',
};

export const MULTIPLE_DEFAULT_VALUES = ATTRIBUTE_CATEGORIES.reduce(
  (values, category) => ({ ...values, [category]: '' }),
  {}
);

export const FEATURE_GRID_COLUMNS = [
  { field: 'ptsFeatureID', headerName: 'Feature ID', width: 140 },
  { field: 'AttributeCategory', headerName: 'Attribute Category', width: 190 },
  { field: 'Attribute', headerName: 'Attribute', width: 190 },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];
